import GssoSignatureDirective from './signature.directive';
import GssoSignatureService from './signature.service';

export default angular.module('app.signature', [])
	.service(GssoSignatureService.id(), GssoSignatureService)
	.directive('ertGssoSignature', GssoSignatureDirective).name;
